module.exports = __webpack_public_path__ + "img/中通冷链.7aca46fa.png";